module.exports = __webpack_public_path__ + "img/27.f8d7013c.jpg";